/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popStake.vue?vue&type=template&id=3de77d1a"
import script from "./popStake.vue?vue&type=script&lang=js"
export * from "./popStake.vue?vue&type=script&lang=js"
import style0 from "./popStake.vue?vue&type=style&index=0&id=3de77d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports